var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketSizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 9V3C36 1.375 34.625 0 33 0H3C1.3125 0 0 1.375 0 3V9C1.625 9 3 10.3125 3 11.9375C3 13.5 1.625 15 0 15V21C0 22.6875 1.3125 24 3 24H33C34.625 24 36 22.6875 36 21V15C34.3125 15 33 13.6875 33 12C33 10.375 34.3125 9 36 9ZM32 12C32 13.875 33.25 15.4375 35 15.875V21C35 22.125 34.0625 23 33 23H3C1.875 23 1 22.125 1 21V15.875C2.6875 15.4375 4 13.875 4 12C4 10.1875 2.6875 8.625 1 8.125V3C1 1.9375 1.875 1 3 1H33C34.0625 1 35 1.9375 35 3V8.1875C33.25 8.625 32 10.1875 32 12ZM28 5H8C7.4375 5 7 5.5 7 6V18C7 18.5625 7.4375 19 8 19H28C28.5 19 29 18.5625 29 18V6C29 5.5 28.5 5 28 5ZM28 18H8V6H28V18Z",
    fill: "#8E9195"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSizeIcon);
export default __webpack_public_path__ + "static/media/ticket-size-icon.2cff556e9fd42874991add96e1029f30.svg";
export { ForwardRef as ReactComponent };